// src/components/QuoteSection.tsx
import React from "react";

const QuoteSection: React.FC = () => {
  return (
    <section className="bg-blue-200 py-16 px-8">
      <div className="max-w-4xl mx-auto text-center">
        {/* Quote */}
        <h2 className="text-2xl md:text-3xl font-semibold text-primary-lightBlue mb-6">
          "The team at Blue Horse Data and their DataStable product have been a
          key part of our direct marketing program for years. Their expertise,
          responsiveness, and thought leadership are invaluable to us as we
          continue to grow and scale our business."
        </h2>

        {/* Attribution */}
        <p className="text-gray-700 text-lg">
          - VP of Marketing, Global Luxury Travel Company
        </p>
      </div>
    </section>
  );
};

export default QuoteSection;
